import { Popup } from '../../../components/Popup'
import HistoryList from './HistoryList'
import './style.scss'
import { useSavingGoalsPopup } from '../Providers/SavingGoalsPopupProvider'

const HistoryGoals = () => {
  const { historyGoalsPopup } = useSavingGoalsPopup()

  const { state, actions } = historyGoalsPopup
  const handleClose = () => actions.close()

  return (
    <Popup
      visible={state.visible}
      onCancel={handleClose}
      title={state.title}
      width={528}
      footer={null}
    >
      <HistoryList />
    </Popup>
  )
}

export default HistoryGoals
